import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../utils/api";
import "./Login.css";

const WHAT = { comments: "new-comment", messages: "new-message" };

/** /unsubscribe?u=&k=&t= — opened from the "Unsubscribe" link in a notification email. */
export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState("working");
  const kind = params.get("k");

  useEffect(() => {
    api.post("/api/email/unsubscribe", { u: params.get("u"), k: kind, t: params.get("t") })
      .then(() => setState("done"))
      .catch(() => setState("invalid"));
  }, [params, kind]);

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Email preferences</h2>
        <div className="auth-form">
          {state === "working" && <p className="auth-forgot-info">Updating your preferences…</p>}
          {state === "done" && (
            <div className="auth-success" role="status">
              You've been unsubscribed from {WHAT[kind] || "these"} notification emails. You'll still receive
              essential emails such as password resets, payment receipts and order confirmations.
            </div>
          )}
          {state === "invalid" && (
            <div className="auth-error" role="alert">
              This unsubscribe link is invalid. Sign in and use Account → Email preferences instead.
            </div>
          )}
          <p className="auth-forgot-help">
            Changed your mind? You can switch notification emails back on in <Link to="/account#settings">Account → Email preferences</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}
